import { Dispatch, SetStateAction, useContext } from "react";
import StyledDataEntryFormSubmitButton from "../../styles/StyledDataEntryFormSubmitButton";
import AppContext from "../../contexts/AppContext";
import DataEntryFormField from "../DataEntryFormField/DataEntryFormField";
import StyledDataEntryForm from "../../styles/StyledDataEntryForm";
import { SubmitHandler, useForm } from "react-hook-form";
import sendEntryData from "../../api/entryDataService";
import FieldInterface from "../../interfaces/FieldInterface";
import DetaEntryFormDisclaimerModal from "../DetaEntryFormDisclaimerModal/DetaEntryFormDisclaimerModal";

interface FormValues {
  [key: string]: string;
}

interface DataEntryFormProps {
  fields: FieldInterface[];
  setDataEntryFormSubmitted: Dispatch<SetStateAction<boolean>>;
  initializeMessages: () => Promise<string | undefined>;
}

const DataEntryForm = ({
  fields,
  setDataEntryFormSubmitted,
  initializeMessages,
}: DataEntryFormProps) => {
  const { configuration, publicKey } = useContext(AppContext);

  if (!configuration) return <></>;
  if (!publicKey) return <></>;

  const getUserDataPromptTitle = () => {
    const defaultTitle = "Before we start";
    if (!configuration) return defaultTitle;
    if (!configuration.translated_labels) return defaultTitle;

    return configuration.translated_labels.user_data_prompt_title;
  };

  const getUserDataPromptButton = () => {
    const defaultButtonLabel = "Let's chat";
    if (!configuration) return defaultButtonLabel;
    if (!configuration.translated_labels) return defaultButtonLabel;

    return configuration.translated_labels.user_data_prompt_button;
  };

  const { register, handleSubmit } = useForm<FormValues>();

  const submitAction = async (data: {
    name?: string;
    company?: string;
    phone_number?: string;
    email?: string;
  }) => {
    const localConversationId = await initializeMessages();
    if (localConversationId) {
      sendEntryData(data, publicKey, localConversationId);
    }
    setDataEntryFormSubmitted(true);
  };

  const onSubmit: SubmitHandler<FormValues> = (data) => submitAction(data);

  return (
    <StyledDataEntryForm onSubmit={handleSubmit(onSubmit)}>
      <div>
        <h3>{getUserDataPromptTitle()}</h3>
        {fields.map((field: FieldInterface, index: number) => {
          return field.type === "field" ? (
            <DataEntryFormField
              register={register}
              key={index}
              field={field.id}
              type={field.input_type}
              label={field.label}
              placeholder={field.placeholder}
            />
          ) : null;
        })}
        {configuration.user_data_prompt_html_disclaimer && (
          <DetaEntryFormDisclaimerModal />
        )}
      </div>

      <div className="actions-container">
        <StyledDataEntryFormSubmitButton
          $backgroundColor={configuration.theme_color}
          type="submit"
        >
          {getUserDataPromptButton()}
        </StyledDataEntryFormSubmitButton>
      </div>
    </StyledDataEntryForm>
  );
};

export default DataEntryForm;
